import { render, staticRenderFns } from "./pos_basic_settings.vue?vue&type=template&id=0bdcc767&scoped=true&"
import script from "./pos_basic_settings.vue?vue&type=script&lang=js&"
export * from "./pos_basic_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdcc767",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bdcc767')) {
      api.createRecord('0bdcc767', component.options)
    } else {
      api.reload('0bdcc767', component.options)
    }
    module.hot.accept("./pos_basic_settings.vue?vue&type=template&id=0bdcc767&scoped=true&", function () {
      api.rerender('0bdcc767', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/pos/pos_settings/tabs/pos_basic_settings.vue"
export default component.exports